import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from '@carbon/icons-react';
import { dismissOpenOverlay } from '../utils/overlayBack';
import './HeaderBackButton.css';

/**
 * HeaderBackButton - strelica „nazad" u zaglavlju.
 *
 * Prikazuje se samo na mobilnom prikazu (ispod 1056px - vidi CSS) i to na
 * „detalj" stranicama gde ZAMENJUJE hamburger dugme (na njegovom mestu - vidi
 * Shell.js i utils/backNavigation.js). Na ostalim stranicama (i na desktopu) u
 * zaglavlju ostaje hamburger.
 *
 * Kada je aplikacija instalirana kao PWA, otvorena je preko celog ekrana i tada
 * na telefonu ne postoji sistemska „nazad" strelica pretraživača, pa je ovo
 * jedini način da se vrati na prethodnu stranicu.
 *
 * `to` je putanja na koju strelica vodi (npr. lista rezidenata/zaposlenih).
 * Ako nije zadata, ponaša se kao obično „nazad" (prethodna stranica).
 *
 * Ako je otvoren panel/modal čiji overlay ne prekriva zaglavlje (npr. panel
 * obaveštenja), „nazad" prvo njega zatvara - isto kao na Androidu (vidi
 * AndroidBackGuard).
 */
const HeaderBackButton = ({ to }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    // Ako je otvoren panel/modal, „nazad" prvo njega zatvara.
    if (dismissOpenOverlay()) return;

    // Kada znamo tačan cilj (npr. lista rezidenata/zaposlenih), idemo pravo
    // tamo - tako „nazad" radi i posle osvežavanja stranice ili dubokog linka.
    if (to) {
      navigate(to);
      return;
    }

    // react-router u history state upisuje `idx` - redni broj unosa u istoriji
    // ove sesije. Ako smo na prvom unosu (idx je 0 ili ga nema - npr. svež
    // ulazak u aplikaciju), nema gde da se ide nazad, pa vodimo na početnu
    // stranu umesto da dugme ne uradi ništa.
    const idx = window.history.state?.idx;
    if (typeof idx === 'number' && idx > 0) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <button
      type="button"
      className="header-back-btn"
      onClick={handleBack}
      aria-label="Nazad"
      title="Nazad"
    >
      <ArrowLeft size={20} />
    </button>
  );
};

export default HeaderBackButton;
